/*
  COREEX smart sticky header.

  Reveals the header on scroll UP, hides it on scroll DOWN — the pattern used by
  many storefronts. Opt-in: only runs when the header carries
  data-coreex-sticky-reveal (set by a header setting), and only while the header
  is actually position:sticky. Focal's own sticky (always-visible) is otherwise
  untouched.

  It toggles two classes on the section WRAPPER, which is the element Focal
  makes sticky, so the whole bar slides as one:
    - coreex-hdr-reveal : added once, carries the CSS transition
    - coreex-hdr-hidden : added/removed as you scroll

  Guards:
    - never hides in the theme editor (the merchant needs to see the header)
    - never hides near the top of the page (avoids a flicker on small scrolls)
    - never hides while the page is scroll-locked by an open drawer/menu, so a
      drawer anchored under the header does not jump
*/
(function () {
  'use strict';

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Focal locks scrolling on <html> when a drawer/menu/popover is open. The
  // exact class has varied across versions, so check the few it has used plus
  // the generic overflow lock.
  function scrollLocked() {
    var el = document.documentElement;
    if (!el) return false;
    if (
      el.classList.contains('lock-scroll') ||
      el.classList.contains('scroll-locked') ||
      el.classList.contains('overflow-hidden')
    ) {
      return true;
    }
    return el.style.overflow === 'hidden' || document.body.style.overflow === 'hidden';
  }

  function init() {
    var header = document.querySelector('store-header[data-coreex-sticky-reveal]');
    if (!header) return;

    var wrap = header.closest('.shopify-section');
    if (!wrap) return;

    // Only meaningful when the header is genuinely sticky. If sticky is off the
    // element scrolls away normally and hiding it would look wrong.
    if (getComputedStyle(wrap).position !== 'sticky') return;

    wrap.classList.add('coreex-hdr-reveal');

    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;

    // Below this the header always shows — stops it hiding on the tiny scrolls
    // near the top and covers the header's own height so it never half-hides.
    function threshold() {
      return wrap.offsetHeight + 40;
    }

    function update() {
      ticking = false;

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var goingDown = y > lastY;
      // ignore sub-pixel jitter
      var moved = Math.abs(y - lastY) > 4;
      lastY = y;

      if (designMode() || scrollLocked()) {
        wrap.classList.remove('coreex-hdr-hidden');
        return;
      }

      if (y <= threshold()) {
        wrap.classList.remove('coreex-hdr-hidden');
        return;
      }

      if (!moved) return;

      if (goingDown) {
        wrap.classList.add('coreex-hdr-hidden');
      } else {
        wrap.classList.remove('coreex-hdr-hidden');
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Header re-rendered in the editor: re-run so the listener and classes attach
  // to the fresh DOM.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('store-header[data-coreex-sticky-reveal]')) {
      init();
    }
  });
})();
